import React from "react";
import { Box } from "@mui/material";

/**
 * Fixed brand ambience behind the whole app: gold and green glows plus the
 * glass shapes from the Teks logo. Purely decorative.
 */
export const AmbientBackground: React.FC<{ intensity?: number }> = ({ intensity = 1 }) => (
  <Box
    aria-hidden
    sx={{
      position: "fixed",
      inset: 0,
      zIndex: 0,
      pointerEvents: "none",
      overflow: "hidden",
      bgcolor: "#000",
    }}
  >
    <Box
      sx={{
        position: "absolute",
        left: { xs: "-45%", md: "10%" },
        top: { xs: -260, md: -320 },
        width: { xs: 760, md: 1150 },
        height: { xs: 640, md: 800 },
        background: `radial-gradient(closest-side, rgba(205,160,117,${0.3 * intensity}), rgba(205,160,117,0) 70%)`,
      }}
    />
    <Box
      sx={{
        position: "absolute",
        right: { xs: -320, md: -220 },
        bottom: { xs: -360, md: -300 },
        width: { xs: 760, md: 980 },
        height: { xs: 760, md: 980 },
        background: `radial-gradient(closest-side, rgba(64,136,86,${0.16 * intensity}), rgba(64,136,86,0) 70%)`,
      }}
    />
    <Box
      component="img"
      src="/transparentLogo.png"
      alt=""
      sx={{
        position: "absolute",
        top: { xs: 10, md: -40 },
        right: { xs: "-38%", md: "-6%" },
        width: { xs: 620, md: 1180 },
        opacity: 0.5 * intensity,
        userSelect: "none",
      }}
    />
    <Box
      component="img"
      src="/circles.png"
      alt=""
      sx={{
        position: "absolute",
        bottom: { xs: -220, md: -360 },
        left: { xs: "-60%", md: "-8%" },
        width: { xs: 900, md: 1150 },
        opacity: 0.3 * intensity,
        userSelect: "none",
      }}
    />
  </Box>
);

export default AmbientBackground;
